// extracted by mini-css-extract-plugin
export default {"resultCalcHeaderSection":"ResultCalcSchedulerHeader_resultCalcHeaderSection__x5gP8","resultCalcHeaderSubSection":"ResultCalcSchedulerHeader_resultCalcHeaderSubSection__jv7s2"};